import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { NgMaterialModule } from './ng-material/ng-material.module';
import { NumberFormatPipe } from 'src/app/pipes/number-format.pipe';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FlexLayoutModule } from '@angular/flex-layout';


import { EmptyStateComponent } from './empty-state/empty-state.component';
import { ErrorStateComponent } from './error-state/error-state.component';
import { BudgetAllocationComponent } from './budget-allocation/budget-allocation.component';
import { FooterComponent } from './footer/footer.component';
import { BgSliderComponent } from './bg-slider/bg-slider.component';
import { HowDoesItWorkComponent } from './footer/how-does-it-work/how-does-it-work.component';
import { ContactsComponent } from './footer/contacts/contacts.component';
import { FootersuccessComponent } from './footer/footersuccess/footersuccess.component';
import { DisclaimerComponent } from './footer/disclaimer/disclaimer.component';
import { PrivacypolicyComponent } from './footer/privacypolicy/privacypolicy.component';
import { AcceptableUsePolicyComponent } from './footer/acceptableusepolicy/acceptableusepolicy.component';
import { WhatsNewComponent } from './footer/whats-new/whats-new.component';
import { ScrollTrackerDirective } from './scroll-tracker.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FeedsDataPreviewComponent } from './data-preview-component/feeds-data-preview-component/feeds-data-preview.component';
import { DataPreviewComponent } from './data-preview-component/data-preview.component';
import { WarningPopup } from './warning-popup/warning-popup';
import { AgreeComponent } from './agree/agree.component';
import { UslEulaComponent } from './agree/usl-eula/usl-eula.component';
import { SensorpreviewComponent } from './sensorpreview/sensorpreview.component';
import { AdvanceSettingsComponent } from './advance-settings/advance-settings.component';
import { ConfirmPopupComponent } from './confirm-popup/confirm-popup.component';
import { PreviescreenComponent } from './previescreen/previescreen.component';
import { CollectionPopupComponent } from './collection-popup/collection-popup.component';
import { TaskcostSensorPreviewComponent } from './data-preview-component/taskcost-sensor-preview/taskcost-sensor-preview.component';
import { EulaIntroductionComponent } from './eula-introduction/eula-introduction.component';
import { CustomTooltipComponent } from './custom-tooltip/custom-tooltip.component';
import { AlertPopupComponent } from './alert-popup/alert-popup.component';
import { PermissionSelectorComponent } from './permission-selector/permission-selector.component';
import { SelectWithFooterComponent } from './select-with-footer/select-with-footer.component';
import { NotaskComponent } from 'src/app/notask/notask.component';
import { TermsOfUseComponent } from './footer/terms-of-use/terms-of-use.component';
import { LeafletMapWrapperComponent } from './leaflet-map-wrapper/leaflet-map-wrapper.component';
import { InlineWarningBannerComponent } from './inline-warning-banner/inline-warning-banner.component';
import { IndicesPreviewComponent } from './data-preview-component/indices-preview/indices-preview.component';
import { LocalTimePickerDialogComponent } from './local-time-picker-dialog/local-time-picker-dialog.component';
import { ActivityLogComponent } from './activity-log/activity-log.component';

const MODULES = [
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  NgxMaterialTimepickerModule,
  NgMaterialModule,
  NgxSpinnerModule,
  FlexLayoutModule
];

@NgModule({
  declarations: [
    NumberFormatPipe,
    EmptyStateComponent,
    ErrorStateComponent,
    BudgetAllocationComponent,
    FooterComponent,
    BgSliderComponent,
    HowDoesItWorkComponent,
    ContactsComponent,
    FootersuccessComponent,
    DisclaimerComponent,
    PrivacypolicyComponent,
    AcceptableUsePolicyComponent,
    WhatsNewComponent,
    ScrollTrackerDirective,
    DataPreviewComponent,
    FeedsDataPreviewComponent,
    WarningPopup,
    AgreeComponent,
    UslEulaComponent,
    SensorpreviewComponent,
    AdvanceSettingsComponent,
    ConfirmPopupComponent,
    PreviescreenComponent,
    CollectionPopupComponent,
    TaskcostSensorPreviewComponent,
    EulaIntroductionComponent,
    CustomTooltipComponent,
    AlertPopupComponent,
    PermissionSelectorComponent,
    SelectWithFooterComponent,
    NotaskComponent,
    TermsOfUseComponent,
    LeafletMapWrapperComponent,
    InlineWarningBannerComponent,
    IndicesPreviewComponent,
    LocalTimePickerDialogComponent,
    ActivityLogComponent
  ],
  imports: [CommonModule, ...MODULES],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [DecimalPipe],
  exports: [
    NumberFormatPipe,
    EmptyStateComponent,
    ErrorStateComponent,
    BudgetAllocationComponent,
    FooterComponent,
    BgSliderComponent,
    HowDoesItWorkComponent,
    ContactsComponent,
    FootersuccessComponent,
    DisclaimerComponent,
    PrivacypolicyComponent,
    AcceptableUsePolicyComponent,
    WhatsNewComponent,
    ScrollTrackerDirective,
    DataPreviewComponent,
    FeedsDataPreviewComponent,
    WarningPopup,
    AgreeComponent,
    UslEulaComponent,
    SensorpreviewComponent,
    AdvanceSettingsComponent,
    ConfirmPopupComponent,
    PreviescreenComponent,
    CollectionPopupComponent,
    TaskcostSensorPreviewComponent,
    EulaIntroductionComponent,
    CustomTooltipComponent,
    AlertPopupComponent,
    PermissionSelectorComponent,
    SelectWithFooterComponent,
    NotaskComponent,
    ...MODULES,
    LeafletMapWrapperComponent,
    InlineWarningBannerComponent,
  ],
})
export class SharedModule {}
